<div class="wrapper">
  <label *ngIf="label" class="label">{{ label }}</label>
  <div class="fields-wrapper" [formGroup]="formGroup">
    <div
      class="field field--country"
      [class.error]="hasError"
      [class.disabled]="disabled"
      (click)="onOpenDropdown()"
    >
      <img
        [alt]="selectedCountry?.code"
        [src]="selectedCountry?.flag"
        class="selected-country__flag"
        [class.disabled]="disabled"
      />
      <span
        id="countries-field"
        class="selected-country"
        [class.disabled]="disabled"
      >
        {{ selectedCountry?.code }}
      </span>
      <em
        class="material-icons selected-country__icon"
        [class.disabled]="disabled"
        >{{ dropdownIcon }}</em
      >
    </div>
    <input
      #phoneInput
      type="text"
      class="field"
      [class.error]="hasError || checkHasError(name)"
      (keyup)="onChangePhoneValue($event.target.value)"
      [formControlName]="name"
      [placeholder]="'Ex: ' + phonePlaceholder"
      tabindex="{{tabindex}}"
      maxlength="15"
    />
  </div>
  <div class="help-block error" *ngFor="let error of getErrorMessages(name)">{{ error }}</div>
</div>

<div
  *ngIf="countriesDropdownStatus"
  class="countries-dropdown__overlay"
  (click)="onCloseDropdown()"
></div>
<div
  #countriesOptionRef
  id="countries-dropdown"
  *ngIf="countriesDropdownStatus"
  class="countries-dropdown"
>
  <div
    *ngFor="let country of countriesOptions"
    [id]="country.code"
    class="countries-dropdown__option"
    (click)="onSelectCountry(country)"
  >
    <img
      [alt]="country.code"
      [src]="country.flag"
      class="countries-dropdown__flag"
    />
    <span>{{ country.code }}</span>
  </div>
</div>
